<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one"><div class="section level2" id="appetizers-all-the-young-dudes-cooking-the-foods">
<div class="section level3" id="dont-fear-the-reapers-hot-sauce-with-coconut-shrimp">
<h3>Don’t Fear the Reapers Hot Sauce with Coconut Shrimp</h3>
<p style="text-indent:0px;">California style heat with a seafood flavour! If you <strong><em>Don’t fear the Reapers</em></strong>, then this hot sauce with Shrimp will not fear you. Serve it with a side of <strong>Blue</strong> Point smoked <strong>Öysters</strong>, and you have a <strong>Cult</strong> favourite.</p>
<br/><p style="font-weight: bold; text-align: center;"><a class="uri">https://www.youtube.com/watch?v=rvuXkYXsgYQ</a></p>
<div class="figure" style="text-align: center;">
<img alt="" src="media/file6.jpg" style="width:4.82671in;height:3.42708in"/>
<p class="caption">A plate of food Description automatically generated with medium confidence</p>
</div>
<h4 style="text-indent:0px;"><strong>Ingredients</strong></h4>
<p style="text-indent:0px;"><strong>For the Sauce</strong></p>
<p style="text-indent:0px;">1 pound California reaper peppers stems removed. Take extra caution when handling peppers of this type. Wear appropriate hand and eye protection and do not rub in eyes or anywhere else for that matter. Watch out for the fumes when cooking! They are <strong><em>Hotter than Hell</em></strong>. You can also use a less hot pepper if you prefer (Scotch Bonnet, etc., etc.).</p>
<p style="text-indent:0px;">4 cloves garlic</p>
<p style="text-indent:0px;">One large onion</p>
<p style="text-indent:0px;">Two Red Bell Peppers</p>
<p style="text-indent:0px;">5 Roma Tomatoes</p>
<p style="text-indent:0px;">1/2 cup of honey</p>
<p style="text-indent:0px;">12 fresh large basil leaves</p>
<p style="text-indent:0px;">1 cup of apple cider vinegar</p>
<p style="text-indent:0px;">1 teaspoon salt</p>
<p style="text-indent:0px;"><strong>Instructions</strong></p>
<br/>
<p style="text-indent:0px;"><strong>1. </strong>Heat the oven to 400 degrees F/200°C Set the reaper peppers and garlic on a baking sheet and bake them about 15-20 minutes, or until the skins slightly char. Always keep an eye on these; you do not want them to burn. Watch out for any fumes.</p>
<p style="text-indent:0px;"><strong>2. </strong>Add peppers to a food processor. Squeeze garlic out of their skins and into the food processor as they go.</p>
<p style="text-indent:0px;"><strong>3. </strong>Add basil leaves and process.</p>
<p style="text-indent:0px;"><strong>4. </strong>While processing, add in vinegar until it is slightly chunky. Watch out for the fumes!</p>
<p style="text-indent:0px;"><strong>5. </strong>Simmer for 30 minutes then add the honey, and blend and simmer for another 20 minutes.</p>
<p style="text-indent:0px;"><strong>6. </strong>Add salt and stir. Push the sauce through a strainer or use a food mill to really strain it.</p>
<p style="text-indent:0px;"><strong>7. </strong>Pour into sterilized bottles and enjoy. Share it with your friends! The longer you let it sit, the more the flavours will meld.</p>
<h4 style="text-indent:0px; padding-bottom:0px; margin-bottom: 0px"><strong>Ingredients</strong></h4>
<p style="text-indent:0px; padding-top:0px; margin-top: 5px"><strong>For the Coconut Shrimp</strong></p>
<br/>
<p style="text-indent:0px;">1/3 cup all-purpose flour (or whole wheat)</p>
<p style="text-indent:0px;">1/2 teaspoon salt</p>
<p style="text-indent:0px;">1/2 teaspoon pepper</p>
<p style="text-indent:0px;">2 large eggs, beaten</p>
<p style="text-indent:0px;">3/4 cup homemade breadcrumbs</p>
<p style="text-indent:0px;">1 cup sweetened shredded coconut</p>
<p style="text-indent:0px;">1-pound raw large shrimp, peeled and deveined with tails attached (For ease I use frozen large cooked shrimp)</p>
<p style="text-indent:0px;">Vegetable oil or coconut oil</p>
<br/>
<p style="text-indent:0px;"><strong>Instructions</strong></p>
<br/>
<p style="text-indent:0px;"><strong>1. </strong>Take out 3 medium bowls. Combine flour, salt, and pepper in one. Beat the eggs in the second bowl. Combine homemade breadcrumbs (I make homemade breadcrumbs out of egg bread, as it gives it a nice yellow colour and tastes great as well.) Add coconut to the third bowl.</p>
<p style="text-indent:0px;"><strong>2. </strong>Dip the shrimp into the flour, then the eggs, and then dredge the shrimp into the coconut mixing, pressing gently to adhere. You want a lot of coconut on each shrimp. Set the coated shrimp aside on a plate as you coat the remaining shrimp.</p>
<p style="text-indent:0px;"><strong>3. </strong>Add enough oil to cover the bottom of a large skillet on medium heat. Fry the coconut shrimp in batches - do not crowd them in the pan. I fry about 6-7 at a time. Flip after 2 minutes and fry the other side for 2 minutes or until the golden-brown shade pops in. I like mine a little darker, so I fry each side for about 3 minutes.</p>
<p style="text-indent:0px;"><strong>4. </strong>Place the finished coconut shrimp on a plate lined with a paper towel as you fry the rest. Serve with your Reapers hot sauce. If too hot for you, you can use orange marmalade as well.</p>
<p style="text-indent:0px;"><strong>5. </strong>Sprinkle with a little chopped cilantro (optional) and serve. Leftover coconut shrimp keeps well in the refrigerator for up to 3 days.</p>
<p style="text-indent:0px;"><strong>6. </strong>You can freeze your fried coconut shrimp, up to 2 months. Reheat for 10 minutes in a 350F oven, or until thawed and warm.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0007.vue?748affde